import React, { useEffect, useState } from "react";
import { useAuthToken } from "./AuthProvider";
import { AppState } from "./store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "./img/enjuggernaut_logo.png";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import useWindowDimensions from "./Account/WindowDimensions";
import arrow_back from "./img/arrow_back_gray.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import visibility from "./img/visibility.svg";
import visibility_off from "./img/visibility_off.svg";

export function Login() {
  const navigate = useNavigate();
  const { updateToken, isAuthenticated, token, isLoading } = useAuthToken();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordVis, setPasswordVis] = useState<boolean>(false);
  const redirect_uri = useSelector((state: AppState) => state.redirect_uri);

  async function googleLogin(cred: string) {
    const apiEndpoint =  "/api/google_login";

    const formData = new FormData();

    formData.append("google_token", cred);

    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const responseData = await response.json();

      if (response.ok) {
        updateToken(responseData.token);
      } else {
        toast.error(responseData.error);
      }
    } catch (error) {
      toast.error("Error logging in!");
    }
  }

  async function submitLogin() {
    const apiEndpoint =  "/api/login";

    const formData = new FormData();

    formData.append("email", email);
    formData.append("password", password);

    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const responseData = await response.json();

      if (response.ok) {
        updateToken(responseData.token);
      } else {
        toast.error(responseData.error);
      }
    } catch (error) {
      toast.error("Error logging in!");
      console.log(error);
    }
  }

  useEffect(() => {
    if (!isLoading && token != "" && token != null) {
      if (redirect_uri.length === 0) {
        navigate("/resumes");
      } else {
        navigate(redirect_uri);
      }
    }
  }, [redirect_uri, token, isLoading]);

  const responseMessage = (response: CredentialResponse) => {
    googleLogin(response.credential === undefined ? "" : response.credential);
  };

  return (
    <div className="light-panel fixed min-h-screen w-full">
      <button
        className="fixed ml-4 mt-4"
        onClick={() => {
          navigate("/");
        }}
      >
        <img src={arrow_back} />
      </button>

      <div className="mx-auto mt-8 w-4/5 rounded-md bg-[#252526] shadow-[0_10px_100px_-2px_rgba(0,0,0,0.3)] md:w-1/2 lg:w-1/2 xl:w-1/3">
        <div className="flex flex-col rounded-md p-4 lg:p-6 xl:p-8 2xl:p-10">
          <img className="mx-auto w-4/5" alt="enjuggernaut logo" src={logo} />

          <h1 className="pt-2 font-code text-lg font-bold text-[#CCCCC1] lg:text-xl xl:pt-4 xl:text-2xl 2xl:pt-8">
            Email
          </h1>
          <input
            className="mt-2 w-full p-2 font-code text-base lg:text-lg xl:text-xl 2xl:p-4"
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setEmail(event.currentTarget.value)
            }
          />

          <h1 className="pt-2 font-code text-lg font-bold text-[#CCCCC1] lg:text-xl xl:pt-4 xl:text-2xl 2xl:pt-8">
            Password
          </h1>
          <div className="relative flex flex-row">
            <input
              type={`${passwordVis ? "text" : "password"}`}
              className="mt-2 w-full p-2 font-code text-base lg:text-lg xl:text-xl 2xl:p-4"
              onChange={(event: React.FormEvent<HTMLInputElement>) =>
                setPassword(event.currentTarget.value)
              }
            />
            <button
              className="absolute right-0 top-4 pr-2 lg:top-5 lg:pr-4 xl:scale-150 2xl:top-7"
              onClick={() => setPasswordVis(!passwordVis)}
            >
              {!passwordVis && <img src={visibility}></img>}

              {passwordVis && <img src={visibility_off}></img>}
            </button>
          </div>

          <button
            className="pt-2 text-left font-code italic text-[#CCCCC1]"
            onClick={() => navigate("/forgot")}
          >
            <span className="text-blue-400">Forgot</span> your password?
          </button>

          <button
            className="login-button mx-auto mt-2 w-1/2 p-3 font-code text-lg font-bold md:text-xl lg:text-2xl xl:mt-6 xl:text-3xl 2xl:mt-12 2xl:text-4xl"
            onClick={() => submitLogin()}
          >
            Login
          </button>

          <hr className="mx-auto my-4 h-1 w-48 rounded border-0 bg-gray-400 md:my-4 2xl:my-12" />

          <div className="mx-auto">
            <GoogleLogin
              size="large"
              shape="rectangular"
              onSuccess={responseMessage}
            />
          </div>

          <button
            className="pt-4 text-left font-code italic text-[#CCCCC1] 2xl:pt-8"
            onClick={() => navigate("/signup")}
          >
            New? Click here to <span className="text-blue-400">sign up</span>!
          </button>
        </div>
      </div>
    </div>
  );
}
